var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEndPoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2C9.91857 2 5 6.8515 5 12.85C5 20.9875 16 30 16 30C16 30 27 20.9875 27 12.85C27 6.8515 22.0814 2 16 2Z",
    fill: "#EE9543"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.821 15.956H12.59V14.039H14.993V13.292H10.286V10.925H14.921V10.178H9.359V14.039H11.663V15.956H8.459V16.721H15.821V15.956ZM20.5943 14.237L21.0353 13.517C19.7843 13.157 19.1003 12.257 19.1003 11.321V11.231H20.8103V10.493H19.1093V9.521H18.1733V10.493H16.4633V11.231H18.1733V11.321C18.1733 12.329 17.4713 13.274 16.2203 13.661L16.6613 14.39C17.6333 14.093 18.2903 13.472 18.6593 12.671C19.0103 13.4 19.6583 13.976 20.5943 14.237ZM23.7353 12.428V11.663H22.5833V9.557H21.6563V14.534H22.5833V12.428H23.7353ZM17.2373 14.921V15.668H21.6563V17.711H22.5833V14.921H17.2373Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndPoint);
export default __webpack_public_path__ + "static/media/endPoint.23113cb343b25e5c3296abead6e3e067.svg";
export { ForwardRef as ReactComponent };